angular.module 'zc.master'

.config ($stateProvider) ->
  $stateProvider
  .state 'admin.master',
    abstract: true
    url: '/master'



// WEBPACK FOOTER //
// ./src/master_admin_modules/master/routes.js.coffee